<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
/* eslint-disable no-unused-expressions, no-restricted-globals, global-require */
export default {
  mounted() {
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    if (location.href.includes("brolly")) {
      import("@/styles/styleBrolly.scss");
      link.href = "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://brolly.cl&size=16";
    } else if (location.href.includes("relif")) {
      import("@/styles/styleRelif.scss");
      link.href = "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://relif.cl&size=16";
    } else {
      import("@/styles/styleAmeris.scss");
      link.href = "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ameris.cl&size=16";
    }
    document.getElementsByTagName("head")[0].appendChild(link);
  },
};
</script>

<style lang="scss">

</style>
